export const relicListTable = [
  {
    prop: 'relicFromUserId',
    label: '编号',
    width: 110,
    sortable: 'custom'
  },
  {
    prop: 'relicName',
    label: '名称',
    width: 300
  },
  {
    prop: 'relicAge',
    label: '年代',
    width: 200
  },
  {
    prop: 'relicTypeEnum',
    label: '类别',
    width: 135
  },
  {
    prop: 'protectionLevelEnum',
    label: '保护级别',
    width: 110
  },
  {
    prop: 'relicDistrictEnum',
    label: '所属',
    width: 110
  }
];
